"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var css = require("./index.scss");
var omi_1 = require("omi");
var SimpleCard = /** @class */ (function (_super) {
    __extends(SimpleCard, _super);
    function SimpleCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleCard.prototype.render = function (props) {
        return omi_1.h("div", { class: "card" },
            omi_1.h("div", { class: "icon" },
                omi_1.h("svg", { viewBox: "64 64 896 896", class: "", "data-icon": "twitter", width: "3em", height: "3em", fill: props.color, "aria-hidden": "true", focusable: "false" },
                    omi_1.h("path", { d: props.path }))),
            omi_1.h("div", { class: "text", style: { background: props.color } },
                omi_1.h("div", { class: "info" }, props.info),
                omi_1.h("span", { class: "caption" }, props.caption)));
    };
    SimpleCard.css = css;
    SimpleCard.propTypes = {
        color: String,
        path: String,
        info: String,
        caption: String
    };
    SimpleCard = __decorate([
        omi_1.tag('m-simple-card')
    ], SimpleCard);
    return SimpleCard;
}(omi_1.WeElement));
exports.default = SimpleCard;
